import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from '@/App'
import '@/index.css'
import { preloadBootRoute, reloadOnPreloadError } from '@/lib/route-chunks'
import { AppProviders } from '@/providers/AppProviders'

// The page in the address bar starts downloading NOW, alongside the cache
// restore and the session check, not after them — see preloadBootRoute.
preloadBootRoute(window.location.pathname)
// A lazy import's CSS or JS that a deploy removed reloads the page once, as a
// stale page chunk does — overlays and stylesheets heal too.
reloadOnPreloadError()

const root = document.getElementById('root')
if (!root) throw new Error('Root element #root not found')

createRoot(root).render(
  <StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </StrictMode>,
)
